import moment from 'moment';
import { z } from 'zod';

// Date number validation schema
const dateOfBirthSchema = z
    .number()
    .refine((value) => {
    if (value === -1)
        return false;
    // Allow null/undefined to pass (will be caught by required)
    if (value == null)
        return true;
    // Must be a valid number and not NaN (can be negative for dates before 1970)
    return typeof value === 'number' && !isNaN(value);
}, { message: 'Enter a valid date' })
    .refine((value) => {
    // Allow null/undefined to pass (will be caught by required)
    if (value == null)
        return true;
    const date = moment(value);
    const now = moment();
    const age = now.diff(date, 'years');
    return age >= 18;
}, { message: 'You must meet the minimum age to continue' })
    .refine((value) => {
    // Allow null/undefined to pass (will be caught by required)
    if (value == null)
        return true;
    const date = moment(value);
    return date.year() >= 1900;
}, { message: 'Enter a year after 1900' });

export { dateOfBirthSchema };
//# sourceMappingURL=dateOfBirth.js.map
